/**
 *  Register Block
 *  See https://babeljs.io/ to construct input and output. Replace "React" with "wp.element"
 *
 *  @param {string} namespace - solver/block - must be unique
 *  @param {object} options - defines what the block renders and how it behaves
 *  @param {string} options.title - Block display name
 *  @param {icon} options.icon - WordPress Dash Icon Reference
 *  @param {category} options.categor - Determines where in block selection to display
 *  @param {object} options.attributes - What kind of options the block contains
 *  Example: 'content: {}' - can be uniquely name/renamed, content: {} -> body: {}
 *  @param {object} options.attributes.type - What kind of input for the option
 *  @param {fun} edit - Block input
 *  @param {fun} save - Block output
 */

const options = {
	title: 'Solver Block',
	icon: 'block-default',
	category: 'common',
	attributes: {
		content: {
			type: 'string',
		},
	},
	edit: function (props) {
		const updateContent = function (event) {
			props.setAttributes({ content: event.target.value });
		};

		return wp.element.createElement(
			'div',
			null,
			wp.element.createElement('h1', null, 'Solver Block'),
			wp.element.createElement('input', {
				type: 'text',
				value: props.attributes.content,
				onChange: updateContent,
			})
		);
	},
	save: function (props) {
		return wp.element.createElement(
			'div',
			{ class: 'solver-block' },
			wp.element.createElement('h1', null, props.attributes.content)
		);
	},
};

wp.blocks.registerBlockType('solver/block', options);
